import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetSlackEvidenceReminderRequest,
  DefaultApiGetSlackEvidenceReminderPerChannelRequest,
  DefaultApiUpdateSlackEvidenceReminderPerChannelRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getSlackEvidenceReminder = async (
  instance: AxiosInstance,
  params: DefaultApiGetSlackEvidenceReminderRequest
) => {
  return await userApiDefaultApiFactory(instance).getSlackEvidenceReminder(
    params
  )
}

export const getSlackEvidenceReminderPerChannel = async (
  instance: AxiosInstance,
  params: DefaultApiGetSlackEvidenceReminderPerChannelRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getSlackEvidenceReminderPerChannel(params)
}

export const updateSlackEvidenceReminderPerChannel = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateSlackEvidenceReminderPerChannelRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateSlackEvidenceReminderPerChannel(params)
}

// Do Not Remove this line ===@import api client===
